import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex flex-col w-full py-5 gap-y-3"
}
const _hoisted_2 = { class: "flex items-center justify-center" }
const _hoisted_3 = { class: "flex items-center justify-between" }
const _hoisted_4 = { class: "flex gap-x-1" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Twitter account is ")
const _hoisted_6 = { class: "font-bold" }
const _hoisted_7 = { class: "w-full" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Tweet History")
const _hoisted_9 = /*#__PURE__*/_createElementVNode("thead", { class: "text-white bg-primary" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "px-2 py-3 text-left" }, "Type"),
    /*#__PURE__*/_createElementVNode("th", { class: "px-2 py-3 text-left" }, "Tweet"),
    /*#__PURE__*/_createElementVNode("th", { class: "px-2 py-3 text-left" }, "Time")
  ])
], -1)
const _hoisted_10 = { class: "px-2 py-3 align-top" }
const _hoisted_11 = { class: "px-1 py-1.5" }
const _hoisted_12 = { class: "px-1 py-1.5 whitespace-pre-wrap bg-gray-100" }
const _hoisted_13 = { class: "px-2 py-3 align-top" }

import TextArea from '@/components/Inputs/TextArea.vue';
import { useSystemStore } from '@/store/system';
import { computed, inject, onMounted, Ref } from 'vue';
import SectionTitle from '@/components/UI/SectionTitle.vue';
import Button from '@/components/UI/Button.vue';
import Spinner from '@/components/UI/Spinner.vue';
import { AlertModal, PromptModal } from '@/typings/modal';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useSystemStore();

const accountLinked = computed(
  () => !!store.configuration?.GlobalTweetId?.length
);

const alertModal = inject('alertModal') as Ref<AlertModal>;

const promptModal = inject('promptModal') as Ref<PromptModal>;

async function unlinkAccount() {
  const doUnlink = await promptModal.value.show(
    'Unlink Master Twitter',
    'You are about to unlink the master twitter account. This will make automated tweets stop. Are you sure?'
  );
  if (doUnlink) {
    await store.unlinkTwitterAccount();
    alertModal.value.show(
      'Master Twitter unlinked',
      'The Master Twitter account has been unlinked. Automated tweets are disabled.'
    );
  }
}

async function linkAccount() {
  const url = await store.linkTwitterAccount();
  if (url) {
    window.location = url;
  }
}

async function save() {
  await store.saveTwitterConfiguration();
  alertModal.value.show(
    'Twitter configuration saved',
    'The Twitter configuration has been saved'
  );
}

onMounted(() => {
  store.getRecentTweets();
  store.getConfiguration();
});

return (_ctx: any,_cache: any) => {
  return (_unref(store).configuration)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(Button, {
            label: "Save Changes",
            onClick: save
          })
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(accountLinked) ? 'Linked' : 'Unlinked'), 1)
          ]),
          _createElementVNode("div", null, [
            (_unref(accountLinked))
              ? (_openBlock(), _createBlock(Button, {
                  key: 0,
                  label: "Unlink Account",
                  onClick: unlinkAccount
                }))
              : (_openBlock(), _createBlock(Button, {
                  key: 1,
                  label: "Link Account",
                  onClick: linkAccount
                }))
          ])
        ]),
        _createVNode(TextArea, {
          modelValue: _unref(store).configuration.EventOpenTweetTemplate,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(store).configuration.EventOpenTweetTemplate) = $event)),
          title: "Scorecard Locks Tweet Template",
          hint: "This template has 3 inputs, {0} = Brand, {1} = Scorecard Title, {2} = Scorecard Hashtags"
        }, null, 8, ["modelValue"]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(SectionTitle, null, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          }),
          _createElementVNode("table", null, [
            _hoisted_9,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).tweets, (log) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: log.tweetID,
                  class: "border-b"
                }, [
                  _createElementVNode("td", _hoisted_10, _toDisplayString(log.TweetType), 1),
                  _createElementVNode("td", _hoisted_11, [
                    _createElementVNode("pre", _hoisted_12, _toDisplayString(log.TweetContent), 1)
                  ]),
                  _createElementVNode("td", _hoisted_13, _toDisplayString(log.SentAt), 1)
                ]))
              }), 128))
            ])
          ])
        ])
      ]))
    : (_openBlock(), _createBlock(Spinner, { key: 1 }))
}
}

})